module.exports = __webpack_public_path__ + "static/media/League-Gothic.b2fa267c.svg";